import React from "react";
import SkeletonBox from "./SkeletonBox";

type IconSkeletonProps = {
  size?: number;
  tone?: "primary" | "secondary" | "overlay" | "light" | "medium" | "dark";
  className?: string;
  style?: React.CSSProperties;
  borderRadius?: number | string;
};

const IconSkeleton = ({
  size = 44,
  tone = "light",
  className = "",
  style = {},
  borderRadius = "50%",
}: IconSkeletonProps) => {
  const toneClass =
    tone === "primary"
      ? "skeleton-primary"
      : tone === "secondary"
      ? "skeleton-secondary"
      : tone === "overlay"
      ? "skeleton-overlay"
      : tone === "medium"
      ? "skeleton-medium"
      : tone === "dark"
      ? "skeleton-dark"
      : "skeleton-light";

  return (
    <SkeletonBox
      width={size}
      height={size}
      className={`${toneClass} ${className}`.trim()}
      style={style}
      borderRadius={borderRadius}
    />
  );
};

export default IconSkeleton;
